import styled from 'styled-components';
import theme from '../../../ui/theme';

const halfGap = 8;
export const DashboardContainer = styled.div`
  padding: 48px 48px 0;

  & .user-info-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: ${2 * halfGap}px;
  }
`;

export const StatisticsContainer = styled.div`
  width: 100%;
  gap: 20px;
  display: flex;
  justify-content: space-between;
  color: ${theme().colors.textPrimary};
  padding-bottom: 56px;

  & > div {
    width: calc(50% - 10px);
  }

  & .chart-wrapper {
    margin-top: 30px;
    height: 220px;
    & canvas {
      height: inherit;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;
    & > div {
      width: 100%;
    }
  }
`;

export const CoursesContainer = styled.div`
  width: 100%;
  margin-bottom: 64px;

  & .title {
    margin-bottom: 15px;
    color: ${theme().colors.textPrimary};
  }

  & .labels {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
    color: ${theme().colors.textPrimary};

    & div {
      width: 33%;
    }
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const FiltersContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  margin-top: 42px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
`;
